import { TimeZone } from "../../entities";
import OldRecordsParser from "./OldRecordsParser";
import { FIXED_PROTOCOL_CONTENT_TYPE_IDS, FIXED_PROTOCOL_TYPE_IDS } from "../../utils/ProtocolTypeUtils";
import PropTransformer from './PropTransformer';
const TIME_ZONE_DATA_TAG = 'TimeZone';
class OldTimeZoneTransformer extends PropTransformer {
    toGateway() {
        return undefined;
    }
    fromGateway(timeZone) {
        if (timeZone) {
            return { tz: timeZone };
        }
        return {};
    }
}
export default class TimeZoneParser extends OldRecordsParser {
    constructor(app) {
        super(FIXED_PROTOCOL_TYPE_IDS.TIME_ZONE, FIXED_PROTOCOL_CONTENT_TYPE_IDS.TIME_ZONE, TIME_ZONE_DATA_TAG, app);
    }
    getPropsMapping() {
        return {
            timeZone: new OldTimeZoneTransformer(),
            tz: 'tz',
        };
    }
    createData(props) {
        return new TimeZone(props.tz);
    }
}
//# sourceMappingURL=TimeZoneParser.js.map